import _ from 'lodash';
import isoCountries from './isoCountries.json';

export default (name) => {
  const country = _.find(isoCountries, (c) => {
    return c.code.toLowerCase() === name.toLowerCase() || c.name.toLowerCase() === name.toLowerCase();
  });
  return country ? country.code : null;
};
